module.exports = __webpack_public_path__ + "static/Macroeconomics-6f027f867f60464cb08742e2b246e3a3.png";